import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RepresentativesComponent } from './representatives/representatives.component';
import { Shell } from '@app/shell/shell.service';
import { AccessType } from '@app/@shared/enums/access-types.enum';
import { AccessGuard } from '@app/@shared/guards/access.guard';
import { NewRepresentativeComponent } from './representatives/components/new-representative/new-representative.component';
import { RepresentativeDetailComponent } from './representatives/components/representative-detail/representative-detail.component';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: ':coalitionId/admin/representatives',
      component: RepresentativesComponent,
      canActivate: [AccessGuard],
      data: { title: 'Representatives', requiredAccessTypes: [AccessType.RepresentativeAdmin] },
    },
    {
      path: ':coalitionId/admin/representatives/new',
      component: NewRepresentativeComponent,
      canActivate: [AccessGuard],
      data: { title: 'New Representative', requiredAccessTypes: [AccessType.RepresentativeAdmin] },
    },
    {
      path: ':coalitionId/admin/representatives/:representativeId',
      component: RepresentativeDetailComponent,
      canActivate: [AccessGuard],
      data: { title: 'Representative', requiredAccessTypes: [AccessType.RepresentativeAdmin] },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
